// require('dotenv').config();

export const ENV = {
    tokenStakingUrl: process.env.REACT_APP_TOKEN_STAKING_URL,
    fundraiserNftUrl: process.env.REACT_APP_FUNDRAISER_NFT_URL,
    nftMarketplaceUrl: process.env.REACT_APP_NFT_MARKETPLACE_URL,
    gamificationUrl: process.env.REACT_APP_GAMIFICATION_URL
}
